import React from 'react';
import { styled } from '@compiled/react';
import { JSErrorPageAsync } from '@jira/platform__js-error-page/src/JSErrorPageAsync.tsx';
import { token } from '@atlaskit/tokens';

export const ErrorPage = ({ error }: { error: Error }): React.JSX.Element => (
	<ErrorWrapper>
		<JSErrorPageAsync error={error} />
	</ErrorWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ErrorWrapper = styled.div({
	backgroundColor: token('elevation.surface'),
	color: token('color.text'),
});
